<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'
import type { StoreSlide } from '~/types/widgets/widgetDtos'
import getWidgetTranslatedMediaUrl from '~/utils/getWidgetTranslatedMediaUrl'
import getWidgetTextTranslation from '~/utils/getWidgetTextTranslation'

const props = defineProps<{
  wrapperClass?: string
  stores: StoreSlide[]
}>()

const { t } = useLang()
</script>

<template>
  <div class="store-slider">
    <ClientOnly>
      <FullSlider>
        <template #sliderContent>
          <SwiperSlide v-for="(store, index) in props.stores" :key="index">
            <div class="store-card flex flex-col text-center p-2 lg:p-4">
              <div class="img-wrapper flex items-center relative h-[200px] lg:h-[330px]">
                <img
                  :src="getWidgetTranslatedMediaUrl(store.image)"
                  class="max-h-full m-auto"
                  :alt="getWidgetTextTranslation(store.title)" />
                <div v-if="getWidgetTextTranslation(store.sticker)" class="absolute top-0 left-0">
                  <Sticker>{{ getWidgetTextTranslation(store.sticker) }}</Sticker>
                </div>
              </div>
              <span class="title font-bold mb-1 h-[1.25rem] lg:h-[1.5rem] lg:text-lg">
                {{ getWidgetTextTranslation(store.title) }}
              </span>
              <span class="text-gray6 dark:text-dmText3 mb-2">{{ store.store }}</span>
              <NuxtLink
                :to="store.slug"
                class="btn-primary"
                :target="store.openLinksInNewTab ? '_blank' : null"
                v-text="t('quotes.visit-store')" />
            </div>
          </SwiperSlide>
        </template>
      </FullSlider>
    </ClientOnly>
  </div>
</template>

<style lang="postcss">
.store-slider {
  position: relative;

  .store-card {
    background: theme('colors.white');
    border-radius: theme('vars.borderRadiusLight');
    border: theme('vars.borderLight');

    .title {
      overflow: hidden;
    }

    .btn-primary {
      font-size: theme('fontSize.sm');
    }
  }
}
</style>
